import { combineReducers } from 'redux';
// reducers
import searchCriteriaReducer from './searchCriteria/searchCriteriaReducer';
import newspapersReducer from './newspapers/newspapersReducer';
import newsGroupsReducer from './newsGroups/newsGroupsReducer';
import appGlobalDataReducer from './appGlobalData/appGlobalDataReducer';
var store = combineReducers({
    searchCriteria: searchCriteriaReducer,
    newspapers: newspapersReducer,
    newsGroups: newsGroupsReducer,
    appGlobalData: appGlobalDataReducer,
});
export default store;
